/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BoxSplitOrderInfoVo } from './BoxSplitOrderInfoVo';
import {
    BoxSplitOrderInfoVoFromJSON,
    BoxSplitOrderInfoVoFromJSONTyped,
    BoxSplitOrderInfoVoToJSON,
    BoxSplitOrderInfoVoToJSONTyped,
} from './BoxSplitOrderInfoVo';

/**
 * 
 * @export
 * @interface ResponseBoxSplitOrderInfoVo
 */
export interface ResponseBoxSplitOrderInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBoxSplitOrderInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBoxSplitOrderInfoVo
     */
    message?: string;
    /**
     * 
     * @type {BoxSplitOrderInfoVo}
     * @memberof ResponseBoxSplitOrderInfoVo
     */
    data?: BoxSplitOrderInfoVo;
}

/**
 * Check if a given object implements the ResponseBoxSplitOrderInfoVo interface.
 */
export function instanceOfResponseBoxSplitOrderInfoVo(value: object): value is ResponseBoxSplitOrderInfoVo {
    return true;
}

export function ResponseBoxSplitOrderInfoVoFromJSON(json: any): ResponseBoxSplitOrderInfoVo {
    return ResponseBoxSplitOrderInfoVoFromJSONTyped(json, false);
}

export function ResponseBoxSplitOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBoxSplitOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BoxSplitOrderInfoVoFromJSON(json['data']),
    };
}

export function ResponseBoxSplitOrderInfoVoToJSON(json: any): ResponseBoxSplitOrderInfoVo {
    return ResponseBoxSplitOrderInfoVoToJSONTyped(json, false);
}

export function ResponseBoxSplitOrderInfoVoToJSONTyped(value?: ResponseBoxSplitOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BoxSplitOrderInfoVoToJSON(value['data']),
    };
}

